import React from "react";
import { useState, useEffect } from "react";
import { TablePagination } from "@mui/material";
import { useOutletContext } from "react-router-dom";
import { getSubscriedUser } from "./helper";
import { useQueryParams } from "../../../hooks";

const tabs = [
  { label: "ONE TIME", value: "ONETIME_SUBSCRIPTION" },
  { label: "MONTHLY RECURRING", value: "MONTHLY" },
  { label: "YEARLY RECURRING", value: "YEARLY" },
  { label: "ADD ON", value: "ADDON" },
];

const addonFilterOptions = [
  { label: "All", value: "" },
  { label: "JOB ADDON", value: "JOB_ADDON" },
  { label: "AI INTERVIEW", value: "AI_INTERVIEW" },
  { label: "MOCK INTERVIEW", value: "MOCK_INTERVIEW" },
];

const PlatformPayments = () => {
  const [userData, setUserData] = useState([]);
  const { getParam, setMultiParam } = useQueryParams();
  const currentPage = getParam("page");
  const currentLimit = getParam("pageSize");
  const [clientsPage, setClientsPage] = useState(parseInt(currentPage) || 0);
  const [clientsLimit, setClientsLimit] = useState(
    parseInt(currentLimit) || 10
  );
  const [userTotal, setUserTotal] = useState(0);
  const [selectedTab, setSelectedTab] = useState('ONETIME_SUBSCRIPTION')
  const [addonFilter, setAddonFilter] = useState('');
  const context = useOutletContext();

  const handleChangePage = (e, newPage) => {
    setClientsPage(newPage);
    fetchInterviewData(newPage, clientsLimit, selectedTab, addonFilter);
  };

  const handleChangeRowsPerPage = (event) => {
    setClientsLimit(parseInt(event.target.value, 10));
    setClientsPage(0);
    fetchInterviewData(0, parseInt(event.target.value, 10), selectedTab, addonFilter);
  };

  const fetchInterviewData = (page, limit, tab, paymentFor = '') => {
    getSubscriedUser(page + 1, limit, tab, paymentFor)
      .then((data) => {
        setUserData(data.data.result);
        setUserTotal(data.data.meta.total);
      })
      .catch((err) => console.log(err));
  };

  const handleTabChange = (tabValue) => {
    setSelectedTab(tabValue);
    setClientsPage(0);
    if (tabValue !== 'ADDON') {
      setAddonFilter('');
    }
  };

  const handleAddonFilterChange = (event) => {
    const filterValue = event.target.value;
    setAddonFilter(filterValue);
    setClientsPage(0);
    fetchInterviewData(0, clientsLimit, selectedTab, filterValue);
  };

  useEffect(() => {
    context(["Payments & Invoices", "Platform Payments"]);
    getSubscriedUser(clientsPage + 1, clientsLimit, selectedTab, addonFilter)
      .then((data) => {
        setUserData(data.data.result);
        setUserTotal(data.data.meta.total);
      })
      .catch((err) => console.log(err));
  }, [selectedTab]);

  useEffect(() => {
    setMultiParam({ page: clientsPage, pageSize: clientsLimit });
  }, [clientsPage, clientsLimit, selectedTab, addonFilter]);

  return (
    <div className="p-5 shadow-md bg-white">
      <div className="flex flex-row justify-between item-center">
        <h3
          className="col-span-5 text-lg uppercase tracking-wider font-bold"
          style={{ color: "#2EBAA3" }}
        >
          Platform Payments
        </h3>
        {selectedTab === 'ADDON' && (
        <div className="mb-4 flex items-center gap-2">
          <select
            value={addonFilter}
            onChange={handleAddonFilterChange}
            className="border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#2EBAA3] focus:border-[#2EBAA3]"
          >
            {addonFilterOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      )}
      </div>
      <br />

      <div className="flex border-b border-gray-300 mb-4 text-sm relative">
        {tabs.map((tab, index) => (
          <button
            key={tab.value}
            className={`relative py-2 px-6 transition-colors duration-300 ease-in-out ${index !== 0 ? "ml-4" : ""
              } ${selectedTab === tab.value
                ? "text-[#2EBAA3] font-semibold"
                : "text-gray-500"
              }`}
            onClick={() => handleTabChange(tab.value)}
          >
            {tab.label}
            <span
              className={`absolute left-0 -bottom-0.5 h-0.5 w-full transform transition-transform duration-300 ease-in-out bg-[#2EBAA3] ${selectedTab === tab.value ? "scale-x-100" : "scale-x-0"
                } origin-left`}
            />
          </button>
        ))}
      </div>
      <div className="overflow-x-auto relative ">
        <table className="w-full text-sm text-left text-gray-500">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50">
            <tr>
              <th scope="col" class="py-3 px-6 uppercase">
                Sr.
              </th>
              <th scope="col" class="py-3 px-6 uppercase">
                Company Name
              </th>
              <th scope="col" class="py-3 px-6 uppercase">
                Email
              </th>
              <th scope="col" class="py-3 px-6 uppercase">
                Username
              </th>
              {
                selectedTab === "ONETIME_SUBSCRIPTION" && (
                  <>
                    <th scope="col" class="py-3 px-6 uppercase">
                      Usage
                    </th>
                    <th scope="col" class="py-3 px-6 uppercase">
                      Amount
                    </th>
                    <th scope="col" class="py-3 px-6 uppercase">
                      Purchase at
                    </th>
                  </>
                )
              }
              {
                selectedTab === "ADDON" && (
                  <>
                    <th scope="col" class="py-3 px-6 uppercase">
                      Payment for
                    </th>
                    <th scope="col" class="py-3 px-6 uppercase">
                      Amount
                    </th>
                    <th scope="col" class="py-3 px-6 uppercase">
                      Purchase at
                    </th>
                  </>
                )
              }
              {selectedTab !== "ONETIME_SUBSCRIPTION" && selectedTab !== "ADDON" && (
                <>
                  <th scope="col" class="py-3 px-6 uppercase">
                    Plan Type
                  </th>
                  <th scope="col" class="py-3 px-6 uppercase">
                    Next Deduction
                  </th>
                </>
              )}
            </tr>
          </thead>
          <tbody>
            {userData?.map((user, index) => {
              return (
                <tr className="bg-white border-b">
                  <th
                    scope="row"
                    class="py-4 px-6 font-medium text-gray-900 whitespace-nowrap cursor-pointer"
                    key={index}
                  >
                    {index + 1}
                  </th>

                  <td className="py-4 px-6 cursor-pointer hover:underline">
                    {user?.user ? user.user.company : ""}
                  </td>
                  <td className="py-4 px-6">
                    {user?.user ? user.user.email : ""}
                  </td>
                  <td className="py-4 px-6">
                    {user?.user ? user.user.username : ""}
                  </td>
                  {selectedTab !== "ONETIME_SUBSCRIPTION" && selectedTab !== 'ADDON' && (
                    <>
                      <td className="py-4 px-6 ">
                        {Array.isArray(user?.attributes)
                          ? user?.attributes[0]?.id
                          : user?.attributes?.id
                        }
                      </td>
                      <td className="py-4 px-2">
                        {user?.end_date
                          ? new Date(user.end_date).toLocaleString("en-GB", {
                              year: "numeric",
                              month: "2-digit",
                              day: "2-digit",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            }).replace(",", "")
                              .replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$2-$1")
                              .replace(" ", ", ")
                          : ""}
                      </td>
                    </>
                  )}
                  {selectedTab === "ONETIME_SUBSCRIPTION" && (
                    <>
                      <td className="py-4 px-6">
                        {user.usage && Object.keys(user.usage).length > 0 ? (
                          <select className="border rounded px-2 py-1 w-full">
                            {Object.entries(user.usage).map(([key, value]) => (
                              <option
                                key={key}
                                value={value === null || value === undefined ? '' : (typeof value === 'object' ? JSON.stringify(value) : value)}
                              >
                                {key}: {
                                  value === null || value === undefined ? 'N/A' :
                                    (typeof value === 'object' && value.type !== undefined) ? value.type :
                                      (typeof value === 'object') ? 'Object' :
                                        (typeof value === 'boolean') ? (value ? 'Yes' : 'No') :
                                          value
                                }
                              </option>
                            ))}
                          </select>
                        ) : (
                          <span>N/A</span>
                        )}
                      </td>
                      <td className="py-4 px-6 ">
                        {user.payment_provider?.toLowerCase() === 'stripe' ? '$' : '₹'}{user?.amount}
                      </td>
                      <td className="py-4 px-6">
                        {user?.created_at
                          ? new Date(user.created_at).toLocaleString("en-GB", {
                              year: "numeric",
                              month: "2-digit",
                              day: "2-digit",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            }).replace(",", "")
                              .replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$2-$1")
                              .replace(" ", ", ")
                          : ""}
                      </td>
                    </>
                  )}
                  {selectedTab === "ADDON" && (
                    <>
                      <td className="py-4 px-6 ">
                        {user?.payment_for ? user.payment_for : "N/A"}
                      </td>
                      <td className="py-4 px-6 ">
                        {user.payment_provider?.toLowerCase() === 'stripe' ? '$' : '₹'}{user?.amount}
                      </td>
                      <td className="py-4 px-6">
                        {user?.created_at
                          ? new Date(user.created_at).toLocaleString("en-GB", {
                              year: "numeric",
                              month: "2-digit",
                              day: "2-digit",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            }).replace(",", "")
                              .replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$2-$1")
                              .replace(" ", ", ")
                          : ""}
                      </td>
                    </>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <TablePagination
        component="div"
        count={userTotal}
        page={clientsPage}
        onPageChange={handleChangePage}
        rowsPerPage={clientsLimit}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[2, 5, 10, 25, 50, 100]}
      />
    </div>
  );
};

export default PlatformPayments;
